import axiosInstance from "utils/axiosInstance";
import {appUrls} from "helpers/Urls";

export const doctorListApi =async ()=>{
    const {data}=await axiosInstance.get(appUrls.doctorList)
    return data
}

export const sendScanApi =async ({formData})=>{
    const {data}=await axiosInstance.post(appUrls.NFCTransaction,formData)
    return data
}